var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeywordTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0_3227_1795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_3227_1795",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3227_1795",
    transform: "translate(-0.131579 -0.131579) scale(0.0263158)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3227_1795",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB2UlEQVRoBe2Uz0rDQBDG8wR6FqF40CfwJDYiKD6EB08ePCiIB/WQYI99DC/ePPgKvfcqJi09KIplJ/1jm1ih0JUIK2HZZme7aRGcwrLd2Znk+36zWcehHxEgAkSACBABIkAE5kvgpjsqeVF85UFc8yDuX7OYn70P+OFzj+83I+6GUNTouyHU3CC63G51S9auKh2+5EPy4EEy8SHhquFBwk/eBny3UagRXg5h4gbsfrPVXZ7JSKU3WvMhflKJVsUu2kO+V2w3frpaDuFxK4xWjU34EN+phObFjl8HRR0l6Tns1shAhX2t+5CM88Sq9tLjdNDsSC8v4PsIYLzTYhtoEx77rKoEYmJHLx9TDYDjcJORvRzKDVZFG/AhqWPEqnLO28P5GAigjjaQXpUqcZhYesVmyWX/m9BPc7O1bgh9tAGM0Lwc6cW/QiwN8JkNTBMk4rIZETedZYNyPRmQiYj1n++ALFC3FsZM57kdIZ1ged9UODZ/5m9AFqhbYwWZ5pEBHXmxb0oWm08dEIR1M5aoaR51QEde7JuSxeZTBwRh3YwlappHHdCRF/umZLH56A7YJp6ucC4P22cutF4Wn64XKsD2ZWTAlqBtPXXAlqBtPXXAliDVE4F/ROAbneiE7kqbOQYAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordTracking);
export default __webpack_public_path__ + "static/media/keyword-tracking.a79bb21046d3fd5a2ab4891e3e5bcb33.svg";
export { ForwardRef as ReactComponent };